import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Press } from "@/components/site/Press";
import { Manifesto } from "@/components/site/Manifesto";
import { BrandMarquee } from "@/components/site/Marquee";
import { Adventures } from "@/components/site/Adventures";
import { Events } from "@/components/site/Events";
import { Cafe } from "@/components/site/Cafe";
import { Gallery, Testimonial } from "@/components/site/Gallery";
import { Newsletter } from "@/components/site/Newsletter";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="grain relative bg-[#f4f1ea]">
      <Navbar />
      <Hero />
      <Press />
      <Manifesto />
      <BrandMarquee />
      <Adventures />
      <Events />
      <Cafe />
      <Gallery />
      <Testimonial />
      <Newsletter />
      <Footer />
    </div>
  );
}
